import type { FormConfig } from '../types';

// section 1
import departmentSelect from '../pages/psfa/departmentSelect';

// section 2
import addDetectedFraud from '../pages/psfa/addDetectedFraud';
import addDetectedError from '../pages/psfa/addDetectedError';

// section 3
import recoveredFraudAndError from '../pages/psfa/recoveredFraudAndError';
import addRecoveredFraud from '../pages/psfa/addRecoveredFraud';
import addRecoveredError from '../pages/psfa/addRecoveredError';

// section 4
import preventedFraudAndError from '../pages/psfa/preventedFraudAndError';
import detailsOfPrevention from '../pages/psfa/detailsOfPrevention';
import addPreventedActual from '../pages/psfa/addPreventedActual';
import addPreventedFraud from '../pages/psfa/addPreventedFraud';
import addPreventedError from '../pages/psfa/addPreventedError';

// section 5
import suspectedFraud from '../pages/psfa/suspectedFraud';
import suspectedBribery from '../pages/psfa/suspectedBribery';
import suspectedWhistleBlowing from '../pages/psfa/suspectedWhistleBlowing';
import fraudInvestigations from '../pages/psfa/fraudInvestigations';
import briberyInvestigations from '../pages/psfa/briberyInvestigations';

// section 6
import civilProsecutionsFraud from '../pages/psfa/civilProsecutionsFraud';
import civilProsecutionsBribery from '../pages/psfa/civilProsecutionsBribery';
import criminalProsecutionsFraud from '../pages/psfa/criminalProsecutionsFraud';
import criminalProsecutionsBribery from '../pages/psfa/criminalProsecutionsBribery';

//section 7
import civilSanctions from '../pages/psfa/civilSanctions';
import criminalSanctions from '../pages/psfa/criminalSanctions';
import civilCostAwards from '../pages/psfa/civilCostAwards';
import criminalCostAwards from '../pages/psfa/criminalCostAwards';
import civilAction from '../pages/psfa/civilAction';
import criminalAction from '../pages/psfa/criminalAction';
import otherBenefits from '../pages/psfa/otherBenefits';

//section 8
import detectedBribery from '../pages/psfa/detectedBribery';
import fraudAgainstThePublic from '../pages/psfa/fraudAgainstThePublic';

import upstreamPrevention from '../pages/psfa/upstreamPrevention';
import departmentalLoss from '../pages/psfa/departmentalLoss';
import fraudAgainstPublic from '../pages/psfa/fraudAgainstPublic';
import briberyAndCorruption from '../pages/psfa/briberyAndCorruption';
import referrals from '../pages/psfa/referrals';

const formConfig: FormConfig = {
  live: true,
  id: 'psfa',
  formName: 'CDR',
  requiredFlag: true,
  listBulkUpload: true,
  listBulkUploadMode: 'table-editor',
  title: 'Consolidated Data Request (CDR)',
  subTitle: 'Summary page',
  identifier: '{sub_organisation|department}',
  showSections: true,
  submitSectionTitle: 'Summary and Review',
  approval: 'optional',
  approvalRequestHint:
    'Forms can be submitted directly to PSFA, or you can send it for approval to another person if your organisation requires it.',
  review: true,
  confirmationEmail: true,
  approvalAllowUnsubmit: true,
  AllowUnapprove: true,
  allowUnlock: 'formClose',
  sections: [
    {
      title: 'Organisation Details',
      slug: 'confirm-details',
      subsections: [
        {
          title: 'Submitting Department/Area',
          slug: 'department-select',
          pages: departmentSelect,
        },
      ],
    },
    {
      title: 'Organisational Reporting Routes & Investigations',
      slug: 'other-fraud',
      subsections: [
        {
          title: 'Allegations of suspected fraud',
          slug: 'suspected-fraud',
          pages: suspectedFraud,
        },
        {
          title: 'Allegations of suspected bribery',
          slug: 'suspected-bribery',
          pages: suspectedBribery,
        },
        {
          title: 'Allegations as a result of whistleblowing',
          slug: 'suspected-wb',
          pages: suspectedWhistleBlowing,
        },
        {
          title: 'Fraud investigations',
          slug: 'fraud-investigations',
          pages: fraudInvestigations,
        },
        {
          title: 'Bribery investigations',
          slug: 'bribery-investigations',
          pages: briberyInvestigations,
        },
      ],
    },
    {
      title: 'Prevented',
      slug: 'prevented-fraud-error',
      subsections: [
        {
          title: 'Prevented Actuals',
          slug: 'prevented-actual',
          pages: addPreventedActual,
        },
        {
          title: 'Future loss prevented (fraud)',
          slug: 'upstream-prevention-fraud',
          pages: addPreventedFraud,
        },
        {
          title: 'Future loss prevented (error)',
          slug: 'upstream-prevention-error',
          pages: addPreventedError,
        },
        {
          title: 'Upstream prevention measures',
          slug: 'do-you-perform-any-upstream-prevention',
          pages: detailsOfPrevention,
        },
      ],
    },
    {
      title: 'Detected',
      slug: 'detected-fraud-error',
      subsections: [
        {
          title: 'Detected fraud',
          slug: 'detected-fraud',
          pages: addDetectedFraud,
        },
        {
          title: 'Detected error',
          slug: 'detected-error',
          pages: addDetectedError,
        },
        {
          title: 'Detected bribery',
          slug: 'detected-bribery',
          pages: detectedBribery,
        },
      ],
    },
    {
      title: 'Recovered',
      slug: 'recovered-fraud-error',
      subsections: [
        {
          title: 'Recovered fraud',
          slug: 'add-an-instance-of-recovered-fraud',
          pages: addRecoveredFraud,
        },
        {
          title: 'Recovered error',
          slug: 'add-an-instance-of-recovered-errors',
          pages: addRecoveredError,
        },
      ],
    },
    {
      title: 'Prosecutions',
      slug: 'prosecutions',
      subsections: [
        {
          title: 'Civil prosecutions for fraud',
          slug: 'civil-prosecutions-fraud',
          pages: civilProsecutionsFraud,
        },
        {
          title: 'Civil prosecutions for bribery',
          slug: 'civil-prosecutions-bribery',
          pages: civilProsecutionsBribery,
        },
        {
          title: 'Criminal prosecutions for fraud',
          slug: 'criminal-prosecutions-fraud',
          pages: criminalProsecutionsFraud,
        },
        {
          title: 'Criminal prosecutions for bribery',
          slug: 'criminal-prosecutions-bribery',
          pages: criminalProsecutionsBribery,
        },
      ],
    },
    {
      title: 'Additional counter fraud benefits',
      slug: 'additional-cf',
      subsections: [
        {
          title: 'Civil sanctions',
          slug: 'civil-sanctions',
          pages: civilSanctions,
        },
        {
          title: 'Criminal sanctions',
          slug: 'criminal-sanctions',
          pages: criminalSanctions,
        },
        {
          title: 'Civil cost awards',
          slug: 'civil-cost-awards',
          pages: civilCostAwards,
        },
        {
          title: 'Criminal cost awards',
          slug: 'criminal-cost-awards',
          pages: criminalCostAwards,
        },
        {
          title: 'Civil action via Proceeds of Crime Act',
          slug: 'civil-action',
          pages: civilAction,
        },
        {
          title: 'Criminal action via Proceeds of Crime Act',
          slug: 'criminal-action',
          pages: criminalAction,
        },
        {
          title: 'Other benefits',
          slug: 'other-benefits',
          pages: otherBenefits,
        },
      ],
    },
    {
      title: 'Frauds against the public',
      slug: 'other-types',
      subsections: [
        {
          title: 'Fraud against the public',
          slug: 'fraud-against-the-public',
          pages: fraudAgainstThePublic,
        },
      ],
    },
  ],
};
export default formConfig;
